
$(document).ready(function() {

  var slickSettings = {
    arrows: false, // Disable the nav arrows
    dots: true,    // Enable pagination dots
    fade: true,    // Enable fade transition
    speed: 600,
    touchThreshold: 10,
    autoplay: true,
    autoplaySpeed: 6000
  };

  $('.news-carousel__slides').slick(slickSettings);

  $('.news-carousel').on('full-width-resize', function(e) {
    $('.news-carousel__slides').slick("unslick").slick(slickSettings);
  });
});